import ChatBot from './ChatBot';
import Loading from './steps_components/common/Loading';

export default ChatBot;
export { Loading };
